// DayZ-style inventory: equipped clothing/backpack items each carry a grid;
// items occupy w×h cells (no rotation yet). Quickbar size comes from clothing.
//
// The model itself lives in ./inv-core.mjs so tools/invtest.mjs can exercise
// it in plain Node (package.json has no "type":"module", so a .js under src/
// cannot be imported from Node — see docs/OVERHAUL.md). This file is the only
// place that knows about the real item catalog; everything else is in the core.
import { ITEMS } from './items';
import { InventoryCore } from './inv-core.mjs';

export class Inventory extends InventoryCore {
  constructor() {
    super(ITEMS);
  }
}
